






















import Vue from 'vue';
import DropZone from './DropZone.vue';
import ImageChanged from './ImageChanged';

interface Data {
  image: File|null,
  dataUrl: string|null,
}

export default Vue.extend({
  components: { DropZone },
  props: {
    url: String,
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      image: null,
      dataUrl: null,
    };
  },
  computed: {
    dynamicUrl(): string|null {
      return this.dataUrl || this.url;
    },
  },
  methods: {
    change(file: File) {
      this
        .preview(file)
        .then(() => {
          const element = this.$el.querySelector('img');
          if (!element) return;
          this.$emit('change', new ImageChanged(
            file, element,
          ));
        });
    },
    preview(file: File): Promise<void> {
      return this
        .toDataUrl(file)
        .then((dataUrl: string) => {
          this.dataUrl = dataUrl;
        });
    },
    toDataUrl(file: File): Promise<string> {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (typeof reader.result === 'string') {
            resolve(reader.result);
          }
        };
        reader.readAsDataURL(file);
      });
    },
  },
});
